import type { Routine } from "instantdb/types";
import { extractDateFromISOString } from "@/utilities/dateFormatter";
import { isRoutineActiveToday } from "@/hooks/routines/useRoutine.utils";

export function calculateProgress(activeDate: string, routines: Routine[]) {
  let totalSteps = 0;
  let completedSteps = 0;

  const processRoutine = (routine: Routine) => {
    // Skip routines that aren't active today
    if (!isRoutineActiveToday(routine)) return;

    const dayCompletedEntry = routine.daysCompleted?.find(
      (dayCompleted) => extractDateFromISOString(dayCompleted.date) === activeDate,
    );

    // Handle routines with no steps
    if (routine.steps?.length === 0) {
      totalSteps += 1; // Count as one unit
      if (dayCompletedEntry?.completed) {
        completedSteps += 1;
      }
      return;
    }

    // Handle routines with steps
    const routineStepIds = (routine.steps ?? []).map((step) => step.id) as string[];
    totalSteps += routineStepIds.length;
    completedSteps += dayCompletedEntry?.stepsCompleted?.length ?? 0;
  };

  // Use for...of instead of forEach as per linter suggestion
  for (const routine of routines) {
    processRoutine(routine);
  }

  return {
    percentage: totalSteps > 0 ? Math.round((completedSteps / totalSteps) * 100) : 0,
    completedSteps,
    totalSteps,
  };
}
